import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';

import {
    CContainer,
    CHeader,
    CHeaderToggler,
    CButton,
    CDropdown,
    CDropdownItem,
    CDropdownMenu,
    CDropdownToggle,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import {
    cilMenu,
    cilAccountLogout,
    cilLockLocked,
} from '@coreui/icons';
import { Link } from 'react-router-dom';
import Breadcrumb from './Breadcrumb';

const Header = () => {
    const headerRef = useRef();
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const asideShow = useSelector((state) => state.asideShow);
    const sidebarShow = useSelector((state) => state.sidebarShow);
    const handleLogout = () => {
        localStorage.clear();

        navigate('/login');
    };
    useEffect(() => {
        document.addEventListener('scroll', () => {
            headerRef.current &&
                headerRef.current.classList.toggle('shadow-sm', document.documentElement.scrollTop > 0);
        });
    }, []);

    return (
        <CHeader position="sticky" className="mb-4 p-0" ref={headerRef}>
            <CContainer className="border-bottom px-4" fluid>
                <CHeaderToggler
                    onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
                    style={{ marginInlineStart: '-14px' }}
                >
                    <CIcon icon={cilMenu} size="lg" />
                </CHeaderToggler>
                <CDropdown >
                    <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
                        <i className="bi bi-person-circle" style={{ fontSize: '1.5rem' }}></i>
                    </CDropdownToggle>
                    <CDropdownMenu className="pt-0" placement="bottom-end">
                        <CDropdownItem>
                            <Link to="/profile" className="nav-link" style={{ color: 'inherit', textDecoration: 'inherit' }}>
                                <i className="bi bi-person" style={{ marginRight: '10px' }}></i>Profile
                            </Link>
                        </CDropdownItem>      
                        <CDropdownItem>
                            <Link to="/change-password" className="nav-link" style={{ color: 'inherit', textDecoration: 'inherit' }}>
                                <CIcon icon={cilLockLocked} style={{ marginRight: '5px' }} /> Change Password
                            </Link>
                        </CDropdownItem>
                        <CDropdownItem onClick={handleLogout}>
                            <CIcon icon={cilAccountLogout} style={{ marginRight: '10px' }} />
                            Logout
                        </CDropdownItem>
                    </CDropdownMenu>
                </CDropdown>
            </CContainer>
            <CContainer className="px-4" fluid>
                <Breadcrumb />
            </CContainer>
        </CHeader>
    );
};

export default Header;